import { m as nr, c as ir, d as sr, e as ar, R as _e, b as Ne, o as lr, f as cr } from "./__searchspring__deps__main-kCZHrJ1L.js";
import { p as ur, $ as dr, a as ce, N as ue, w as de, c as fr, E as Fe } from "./__searchspring__deps__compat.module-ZWqUX18Z.js";
if (!ur)
  throw new Error("mobx-react-lite requires React with Hooks support");
if (!nr)
  throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");
function pr(e) {
  e();
}
function br(e) {
  e || (e = pr), ir({ reactionScheduler: e });
}
function gr(e) {
  return sr(e);
}
var mr = 1e4, hr = 1e4, yr = (
  /** @class */
  function() {
    function e(r) {
      var t = this;
      Object.defineProperty(this, "finalize", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
      }), Object.defineProperty(this, "registrations", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: /* @__PURE__ */ new Map()
      }), Object.defineProperty(this, "sweepTimeout", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: void 0
      }), Object.defineProperty(this, "sweep", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function(o) {
          o === void 0 && (o = mr), clearTimeout(t.sweepTimeout), t.sweepTimeout = void 0;
          var s = Date.now();
          t.registrations.forEach(function(n, i) {
            s - n.registeredAt >= o && (t.finalize(n.value), t.registrations.delete(i));
          }), t.registrations.size > 0 && t.scheduleSweep();
        }
      }), Object.defineProperty(this, "finalizeAllImmediately", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function() {
          t.sweep(0);
        }
      });
    }
    return Object.defineProperty(e.prototype, "register", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(r, t, o) {
        this.registrations.set(o, {
          value: t,
          registeredAt: Date.now()
        }), this.scheduleSweep();
      }
    }), Object.defineProperty(e.prototype, "unregister", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(r) {
        this.registrations.delete(r);
      }
    }), Object.defineProperty(e.prototype, "scheduleSweep", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function() {
        this.sweepTimeout === void 0 && (this.sweepTimeout = setTimeout(this.sweep, hr));
      }
    }), e;
  }()
), vr = typeof FinalizationRegistry < "u" ? FinalizationRegistry : yr, X = new vr(function(e) {
  var r;
  (r = e.reaction) === null || r === void 0 || r.dispose(), e.reaction = null;
}), Ue = { exports: {} }, Le = {};
const wr = /* @__PURE__ */ ar(dr);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var U = wr;
function xr(e, r) {
  return e === r && (e !== 0 || 1 / e === 1 / r) || e !== e && r !== r;
}
var Sr = typeof Object.is == "function" ? Object.is : xr, kr = U.useState, Rr = U.useEffect, Ar = U.useLayoutEffect, Mr = U.useDebugValue;
function zr(e, r) {
  var t = r(), o = kr({ inst: { value: t, getSnapshot: r } }), s = o[0].inst, n = o[1];
  return Ar(function() {
    s.value = t, s.getSnapshot = r, ie(s) && n({ inst: s });
  }, [e, t, r]), Rr(function() {
    return ie(s) && n({ inst: s }), e(function() {
      ie(s) && n({ inst: s });
    });
  }, [e]), Mr(t), t;
}
function ie(e) {
  var r = e.getSnapshot;
  e = e.value;
  try {
    var t = r();
    return !Sr(e, t);
  } catch {
    return !0;
  }
}
function jr(e, r) {
  return r();
}
var Or = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? jr : zr;
Le.useSyncExternalStore = U.useSyncExternalStore !== void 0 ? U.useSyncExternalStore : Or;
Ue.exports = Le;
var Er = Ue.exports, $r = function() {
};
function we(e) {
  e.reaction = new _e("observer".concat(e.name), function() {
    var r;
    e.stateVersion = Symbol(), (r = e.onStoreChange) === null || r === void 0 || r.call(e);
  });
}
function Pr(e, r) {
  r === void 0 && (r = "observed");
  var t = ce.useRef(null);
  if (!t.current) {
    var o = {
      reaction: null,
      onStoreChange: null,
      stateVersion: Symbol(),
      name: r,
      subscribe: function(a) {
        return X.unregister(o), o.onStoreChange = a, o.reaction || (we(o), o.stateVersion = Symbol()), function() {
          var c;
          o.onStoreChange = null, (c = o.reaction) === null || c === void 0 || c.dispose(), o.reaction = null;
        };
      },
      getSnapshot: function() {
        return o.stateVersion;
      }
    };
    t.current = o;
  }
  var s = t.current;
  s.reaction || (we(s), X.register(t, s, s)), ce.useDebugValue(s.reaction, gr), Er.useSyncExternalStore(
    // Both of these must be stable, otherwise it would keep resubscribing every render.
    s.subscribe,
    s.getSnapshot,
    $r
  );
  var n, i;
  if (s.reaction.track(function() {
    try {
      n = e();
    } catch (a) {
      i = a;
    }
  }), i)
    throw i;
  return n;
}
var We = typeof Symbol == "function" && Symbol.for, xe = We ? Symbol.for("react.forward_ref") : typeof ue == "function" && ue(function(e) {
  return null;
}).$$typeof, Se = We ? Symbol.for("react.memo") : typeof de == "function" && de(function(e) {
  return null;
}).$$typeof;
function Cr(e, r) {
  var t;
  if (Se && e.$$typeof === Se)
    throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
  var o = (t = r == null ? void 0 : r.forwardRef) !== null && t !== void 0 ? t : !1, s = e, n = e.displayName || e.name;
  if (xe && e.$$typeof === xe && (o = !0, s = e.render, typeof s != "function"))
    throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
  var i = function(a, c) {
    return Pr(function() {
      return s(a, c);
    }, n);
  };
  return i.displayName = e.displayName, Object.defineProperty(i, "name", {
    value: e.name,
    writable: !0,
    configurable: !0
  }), e.contextTypes && (i.contextTypes = e.contextTypes), o && (i = ue(i)), i = de(i), Ir(e, i), i;
}
var Tr = {
  $$typeof: !0,
  render: !0,
  compare: !0,
  type: !0,
  // Don't redefine `displayName`,
  // it's defined as getter-setter pair on `memo` (see #3192).
  displayName: !0
};
function Ir(e, r) {
  Object.keys(e).forEach(function(t) {
    Tr[t] || Object.defineProperty(r, t, Object.getOwnPropertyDescriptor(e, t));
  });
}
var se;
br(fr);
se = X.finalizeAllImmediately;
function Vr(e, r) {
  if (ke(e, r))
    return !0;
  if (typeof e != "object" || e === null || typeof r != "object" || r === null)
    return !1;
  var t = Object.keys(e), o = Object.keys(r);
  if (t.length !== o.length)
    return !1;
  for (var s = 0; s < t.length; s++)
    if (!Object.hasOwnProperty.call(r, t[s]) || !ke(e[t[s]], r[t[s]]))
      return !1;
  return !0;
}
function ke(e, r) {
  return e === r ? e !== 0 || 1 / e === 1 / r : e !== e && r !== r;
}
var Re = /* @__PURE__ */ Symbol("patchMixins"), Be = /* @__PURE__ */ Symbol("patchedDefinition");
function Gr(e, r) {
  var t = e[Re] = e[Re] || {}, o = t[r] = t[r] || {};
  return o.locks = o.locks || 0, o.methods = o.methods || [], o;
}
function Ae(e, r) {
  for (var t = this, o = arguments.length, s = new Array(o > 2 ? o - 2 : 0), n = 2; n < o; n++)
    s[n - 2] = arguments[n];
  r.locks++;
  try {
    var i;
    return e != null && (i = e.apply(this, s)), i;
  } finally {
    r.locks--, r.locks === 0 && r.methods.forEach(function(a) {
      a.apply(t, s);
    });
  }
}
function Me(e, r) {
  var t = function() {
    for (var s = arguments.length, n = new Array(s), i = 0; i < s; i++)
      n[i] = arguments[i];
    Ae.call.apply(Ae, [this, e, r].concat(n));
  };
  return t;
}
function _r(e, r, t) {
  var o = Gr(e, r);
  o.methods.indexOf(t) < 0 && o.methods.push(t);
  var s = Object.getOwnPropertyDescriptor(e, r);
  if (!(s && s[Be])) {
    var n = e[r], i = De(e, r, s ? s.enumerable : void 0, o, n);
    Object.defineProperty(e, r, i);
  }
}
function De(e, r, t, o, s) {
  var n, i = Me(s, o);
  return n = {}, n[Be] = !0, n.get = function() {
    return i;
  }, n.set = function(c) {
    if (this === e)
      i = Me(c, o);
    else {
      var w = De(this, r, t, o, c);
      Object.defineProperty(this, r, w);
    }
  }, n.configurable = !0, n.enumerable = t, n;
}
var ze = /* @__PURE__ */ Symbol("ObserverAdministration"), je = /* @__PURE__ */ Symbol("isMobXReactObserver");
function fe(e) {
  var r;
  return (r = e[ze]) != null ? r : e[ze] = {
    reaction: null,
    mounted: !1,
    reactionInvalidatedBeforeMount: !1,
    forceUpdate: null,
    name: pe(e.constructor),
    state: void 0,
    props: void 0,
    context: void 0
  };
}
function Nr(e) {
  var r = e.prototype;
  if (e[je]) {
    var t = pe(e);
    throw new Error("The provided component class (" + t + ") has already been declared as an observer component.");
  } else
    e[je] = !0;
  if (r.componentWillReact)
    throw new Error("The componentWillReact life-cycle event is no longer supported");
  if (e.__proto__ !== Fe) {
    if (!r.shouldComponentUpdate)
      r.shouldComponentUpdate = Oe;
    else if (r.shouldComponentUpdate !== Oe)
      throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
  }
  var o = r.render;
  if (typeof o != "function") {
    var s = pe(e);
    throw new Error("[mobx-react] class component (" + s + ") is missing `render` method.\n`observer` requires `render` being a function defined on prototype.\n`render = () => {}` or `render = function() {}` is not supported.");
  }
  r.render = function() {
    return Object.defineProperty(this, "render", {
      // There is no safe way to replace render, therefore it's forbidden.
      configurable: !1,
      writable: !1,
      value: Fr.call(this, o)
    }), this.render();
  };
  var n = r.componentDidMount;
  return r.componentDidMount = function() {
    var i = this, a = fe(this);
    return a.mounted = !0, X.unregister(this), a.forceUpdate = function() {
      return i.forceUpdate();
    }, (!a.reaction || a.reactionInvalidatedBeforeMount) && a.forceUpdate(), n == null ? void 0 : n.apply(this, arguments);
  }, _r(r, "componentWillUnmount", function() {
    var i, a = fe(this);
    (i = a.reaction) == null || i.dispose(), a.reaction = null, a.forceUpdate = null, a.mounted = !1, a.reactionInvalidatedBeforeMount = !1;
  }), e;
}
function pe(e) {
  return e.displayName || e.name || "<component>";
}
function Fr(e) {
  var r = e.bind(this), t = fe(this);
  function o() {
    t.reaction || (t.reaction = Ur(t), t.mounted || X.register(this, t, this));
    var s = void 0, n = void 0;
    if (t.reaction.track(function() {
      try {
        n = cr(!1, r);
      } catch (i) {
        s = i;
      }
    }), s)
      throw s;
    return n;
  }
  return o;
}
function Ur(e) {
  return new _e(e.name + ".render()", function() {
    if (!e.mounted) {
      e.reactionInvalidatedBeforeMount = !0;
      return;
    }
    try {
      e.forceUpdate == null || e.forceUpdate();
    } catch {
      var r;
      (r = e.reaction) == null || r.dispose(), e.reaction = null;
    }
  });
}
function Oe(e, r) {
  return this.state !== r ? !0 : !Vr(this.props, e);
}
function zt(e, r) {
  if (r && r.kind !== "class")
    throw new Error("The @observer decorator can be used on classes only");
  return e.isMobxInjector === !0 && console.warn("Mobx observer: You are trying to use `observer` on a component that already has `inject`. Please apply `observer` before applying `inject`"), Object.prototype.isPrototypeOf.call(Ne, e) || Object.prototype.isPrototypeOf.call(Fe, e) ? Nr(e) : Cr(e);
}
ce.version.split(".")[0];
if (!Ne)
  throw new Error("mobx-react requires React to be available");
if (!lr)
  throw new Error("mobx-react requires mobx to be available");
const jt = (e, r) => {
  try {
    return JSON.parse(e);
  } catch {
    return r ?? {};
  }
};
var Ve, Ge;
const Ot = (Ve = window == null ? void 0 : window.Shopify) != null && Ve.locale && ((Ge = window == null ? void 0 : window.Shopify) != null && Ge.country) ? window.Shopify.locale.includes("-") ? window.Shopify.locale : window.Shopify.locale + "-" + window.Shopify.country : null, ae = /\{\{\s*(\w+)\s*\}\}/, Lr = /(\d)(?=(\d\d\d)+(?!\d))/g, Ee = (window == null ? void 0 : window.shopify_money_format) || "{{amount}}";
function G(e, r = 2, t = ",", o = ".") {
  if (isNaN(e) || e == null)
    return "0";
  const n = (e / 100).toFixed(r).split("."), i = n[0].replace(Lr, `$1${t}`), a = n[1] ? o + n[1] : "";
  return i + a;
}
function Et(e, r) {
  let t = e, o = "", s = r || Ee, n = s.match(ae);
  if (n || (s = Ee, n = s.match(ae)), !n)
    return G(t);
  switch (n[1]) {
    case "amount":
      o = G(t);
      break;
    case "amount_no_decimals":
      o = G(t, 0);
      break;
    case "amount_with_comma_separator":
      o = G(t, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      o = G(t, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      o = G(t, 0, " ");
      break;
    default:
      o = G(t);
  }
  return s.replace(ae, o);
}
const ye = "-";
function Wr(e) {
  const r = Dr(e), {
    conflictingClassGroups: t,
    conflictingClassGroupModifiers: o
  } = e;
  function s(i) {
    const a = i.split(ye);
    return a[0] === "" && a.length !== 1 && a.shift(), qe(a, r) || Br(i);
  }
  function n(i, a) {
    const c = t[i] || [];
    return a && o[i] ? [...c, ...o[i]] : c;
  }
  return {
    getClassGroupId: s,
    getConflictingClassGroupIds: n
  };
}
function qe(e, r) {
  var i;
  if (e.length === 0)
    return r.classGroupId;
  const t = e[0], o = r.nextPart.get(t), s = o ? qe(e.slice(1), o) : void 0;
  if (s)
    return s;
  if (r.validators.length === 0)
    return;
  const n = e.join(ye);
  return (i = r.validators.find(({
    validator: a
  }) => a(n))) == null ? void 0 : i.classGroupId;
}
const $e = /^\[(.+)\]$/;
function Br(e) {
  if ($e.test(e)) {
    const r = $e.exec(e)[1], t = r == null ? void 0 : r.substring(0, r.indexOf(":"));
    if (t)
      return "arbitrary.." + t;
  }
}
function Dr(e) {
  const {
    theme: r,
    prefix: t
  } = e, o = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return Jr(Object.entries(e.classGroups), t).forEach(([n, i]) => {
    be(i, o, n, r);
  }), o;
}
function be(e, r, t, o) {
  e.forEach((s) => {
    if (typeof s == "string") {
      const n = s === "" ? r : Pe(r, s);
      n.classGroupId = t;
      return;
    }
    if (typeof s == "function") {
      if (qr(s)) {
        be(s(o), r, t, o);
        return;
      }
      r.validators.push({
        validator: s,
        classGroupId: t
      });
      return;
    }
    Object.entries(s).forEach(([n, i]) => {
      be(i, Pe(r, n), t, o);
    });
  });
}
function Pe(e, r) {
  let t = e;
  return r.split(ye).forEach((o) => {
    t.nextPart.has(o) || t.nextPart.set(o, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), t = t.nextPart.get(o);
  }), t;
}
function qr(e) {
  return e.isThemeGetter;
}
function Jr(e, r) {
  return r ? e.map(([t, o]) => {
    const s = o.map((n) => typeof n == "string" ? r + n : typeof n == "object" ? Object.fromEntries(Object.entries(n).map(([i, a]) => [r + i, a])) : n);
    return [t, s];
  }) : e;
}
function Yr(e) {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let r = 0, t = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
  function s(n, i) {
    t.set(n, i), r++, r > e && (r = 0, o = t, t = /* @__PURE__ */ new Map());
  }
  return {
    get(n) {
      let i = t.get(n);
      if (i !== void 0)
        return i;
      if ((i = o.get(n)) !== void 0)
        return s(n, i), i;
    },
    set(n, i) {
      t.has(n) ? t.set(n, i) : s(n, i);
    }
  };
}
const Je = "!";
function Kr(e) {
  const r = e.separator, t = r.length === 1, o = r[0], s = r.length;
  return function(i) {
    const a = [];
    let c = 0, w = 0, f;
    for (let x = 0; x < i.length; x++) {
      let k = i[x];
      if (c === 0) {
        if (k === o && (t || i.slice(x, x + s) === r)) {
          a.push(i.slice(w, x)), w = x + s;
          continue;
        }
        if (k === "/") {
          f = x;
          continue;
        }
      }
      k === "[" ? c++ : k === "]" && c--;
    }
    const R = a.length === 0 ? i : i.substring(w), M = R.startsWith(Je), O = M ? R.substring(1) : R, E = f && f > w ? f - w : void 0;
    return {
      modifiers: a,
      hasImportantModifier: M,
      baseClassName: O,
      maybePostfixModifierPosition: E
    };
  };
}
function Xr(e) {
  if (e.length <= 1)
    return e;
  const r = [];
  let t = [];
  return e.forEach((o) => {
    o[0] === "[" ? (r.push(...t.sort(), o), t = []) : t.push(o);
  }), r.push(...t.sort()), r;
}
function Zr(e) {
  return {
    cache: Yr(e.cacheSize),
    splitModifiers: Kr(e),
    ...Wr(e)
  };
}
const Hr = /\s+/;
function Qr(e, r) {
  const {
    splitModifiers: t,
    getClassGroupId: o,
    getConflictingClassGroupIds: s
  } = r, n = /* @__PURE__ */ new Set();
  return e.trim().split(Hr).map((i) => {
    const {
      modifiers: a,
      hasImportantModifier: c,
      baseClassName: w,
      maybePostfixModifierPosition: f
    } = t(i);
    let R = o(f ? w.substring(0, f) : w), M = !!f;
    if (!R) {
      if (!f)
        return {
          isTailwindClass: !1,
          originalClassName: i
        };
      if (R = o(w), !R)
        return {
          isTailwindClass: !1,
          originalClassName: i
        };
      M = !1;
    }
    const O = Xr(a).join(":");
    return {
      isTailwindClass: !0,
      modifierId: c ? O + Je : O,
      classGroupId: R,
      originalClassName: i,
      hasPostfixModifier: M
    };
  }).reverse().filter((i) => {
    if (!i.isTailwindClass)
      return !0;
    const {
      modifierId: a,
      classGroupId: c,
      hasPostfixModifier: w
    } = i, f = a + c;
    return n.has(f) ? !1 : (n.add(f), s(c, w).forEach((R) => n.add(a + R)), !0);
  }).reverse().map((i) => i.originalClassName).join(" ");
}
function et() {
  let e = 0, r, t, o = "";
  for (; e < arguments.length; )
    (r = arguments[e++]) && (t = Ye(r)) && (o && (o += " "), o += t);
  return o;
}
function Ye(e) {
  if (typeof e == "string")
    return e;
  let r, t = "";
  for (let o = 0; o < e.length; o++)
    e[o] && (r = Ye(e[o])) && (t && (t += " "), t += r);
  return t;
}
function ge(e, ...r) {
  let t, o, s, n = i;
  function i(c) {
    const w = r.reduce((f, R) => R(f), e());
    return t = Zr(w), o = t.cache.get, s = t.cache.set, n = a, a(c);
  }
  function a(c) {
    const w = o(c);
    if (w)
      return w;
    const f = Qr(c, t);
    return s(c, f), f;
  }
  return function() {
    return n(et.apply(null, arguments));
  };
}
function S(e) {
  const r = (t) => t[e] || [];
  return r.isThemeGetter = !0, r;
}
const Ke = /^\[(?:([a-z-]+):)?(.+)\]$/i, rt = /^\d+\/\d+$/, tt = /* @__PURE__ */ new Set(["px", "full", "screen"]), ot = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, nt = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, it = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, st = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, at = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function C(e) {
  return _(e) || tt.has(e) || rt.test(e);
}
function I(e) {
  return L(e, "length", gt);
}
function _(e) {
  return !!e && !Number.isNaN(Number(e));
}
function re(e) {
  return L(e, "number", _);
}
function J(e) {
  return !!e && Number.isInteger(Number(e));
}
function lt(e) {
  return e.endsWith("%") && _(e.slice(0, -1));
}
function u(e) {
  return Ke.test(e);
}
function V(e) {
  return ot.test(e);
}
const ct = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
function ut(e) {
  return L(e, ct, Xe);
}
function dt(e) {
  return L(e, "position", Xe);
}
const ft = /* @__PURE__ */ new Set(["image", "url"]);
function pt(e) {
  return L(e, ft, ht);
}
function bt(e) {
  return L(e, "", mt);
}
function Y() {
  return !0;
}
function L(e, r, t) {
  const o = Ke.exec(e);
  return o ? o[1] ? typeof r == "string" ? o[1] === r : r.has(o[1]) : t(o[2]) : !1;
}
function gt(e) {
  return nt.test(e) && !it.test(e);
}
function Xe() {
  return !1;
}
function mt(e) {
  return st.test(e);
}
function ht(e) {
  return at.test(e);
}
function me() {
  const e = S("colors"), r = S("spacing"), t = S("blur"), o = S("brightness"), s = S("borderColor"), n = S("borderRadius"), i = S("borderSpacing"), a = S("borderWidth"), c = S("contrast"), w = S("grayscale"), f = S("hueRotate"), R = S("invert"), M = S("gap"), O = S("gradientColorStops"), E = S("gradientColorStopPositions"), x = S("inset"), k = S("margin"), P = S("opacity"), h = S("padding"), H = S("saturate"), N = S("scale"), Q = S("sepia"), ee = S("skew"), W = S("space"), B = S("translate"), F = () => ["auto", "contain", "none"], D = () => ["auto", "hidden", "clip", "visible", "scroll"], q = () => ["auto", u, r], l = () => [u, r], p = () => ["", C, I], d = () => ["auto", _, u], g = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], b = () => ["solid", "dashed", "dotted", "double", "none"], m = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"], y = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], v = () => ["", "0", u], A = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], $ = () => [_, re], j = () => [_, u];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Y],
      spacing: [C, I],
      blur: ["none", "", V, u],
      brightness: $(),
      borderColor: [e],
      borderRadius: ["none", "", "full", V, u],
      borderSpacing: l(),
      borderWidth: p(),
      contrast: $(),
      grayscale: v(),
      hueRotate: j(),
      invert: v(),
      gap: l(),
      gradientColorStops: [e],
      gradientColorStopPositions: [lt, I],
      inset: q(),
      margin: q(),
      opacity: $(),
      padding: l(),
      saturate: $(),
      scale: $(),
      sepia: v(),
      skew: j(),
      space: l(),
      translate: l()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", u]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [V]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": A()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": A()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...g(), u]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: D()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": D()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": D()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: F()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": F()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": F()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [x]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [x]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [x]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [x]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [x]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [x]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [x]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [x]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [x]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", J, u]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: q()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", u]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: v()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: v()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", J, u]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Y]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", J, u]
        }, u]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": d()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": d()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Y]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [J, u]
        }, u]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": d()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": d()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", u]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", u]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [M]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [M]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [M]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...y()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...y(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...y(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [h]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [h]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [h]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [h]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [h]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [h]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [h]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [h]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [h]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [k]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [k]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [k]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [k]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [k]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [k]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [k]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [k]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [k]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [W]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [W]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", u, r]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [u, r, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [u, r, "none", "full", "min", "max", "fit", "prose", {
          screen: [V]
        }, V]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [u, r, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [u, r, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [u, r, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [u, r, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", V, I]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", re]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Y]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", u]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", _, re]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", C, u]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", u]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", u]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [P]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [P]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...b(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", C, I]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", C, u]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: l()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", u]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", u]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [P]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...g(), dt]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", ut]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, pt]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [E]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [E]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [E]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [O]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [O]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [O]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [n]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [n]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [n]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [n]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [n]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [n]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [n]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [n]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [n]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [n]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [n]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [n]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [n]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [n]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [n]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [a]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [a]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [a]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [a]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [a]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [a]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [a]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [a]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [a]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [P]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...b(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [a]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [a]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [P]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: b()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [s]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [s]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [s]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [s]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [s]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [s]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [s]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [s]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...b()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [C, u]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [C, I]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: p()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [P]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [C, I]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", V, bt]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Y]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [P]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": m()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": m()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [t]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [o]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", V, u]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [w]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [f]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [R]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [H]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [Q]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [t]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [o]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [w]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [f]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [R]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [P]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [H]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [Q]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [i]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [i]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [i]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", u]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: j()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", u]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: j()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", u]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [N]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [N]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [N]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [J, u]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [B]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [B]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [ee]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [ee]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", u]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", u]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": l()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": l()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": l()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": l()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": l()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": l()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": l()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": l()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": l()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": l()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": l()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": l()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": l()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": l()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": l()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": l()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": l()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": l()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", u]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [C, I, re]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
function yt(e, {
  cacheSize: r,
  prefix: t,
  separator: o,
  extend: s = {},
  override: n = {}
}) {
  te(e, "cacheSize", r), te(e, "prefix", t), te(e, "separator", o);
  for (const i in n)
    vt(e[i], n[i]);
  for (const i in s)
    wt(e[i], s[i]);
  return e;
}
function te(e, r, t) {
  t !== void 0 && (e[r] = t);
}
function vt(e, r) {
  if (r)
    for (const t in r)
      te(e, t, r[t]);
}
function wt(e, r) {
  if (r)
    for (const t in r) {
      const o = r[t];
      o !== void 0 && (e[t] = (e[t] || []).concat(o));
    }
}
function xt(e, ...r) {
  return typeof e == "function" ? ge(me, e, ...r) : ge(() => yt(me(), e), ...r);
}
const St = /* @__PURE__ */ ge(me);
var Ce = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, z = (e) => !e || typeof e != "object" || Object.keys(e).length === 0, kt = (e, r) => JSON.stringify(e) === JSON.stringify(r);
function Ze(e, r) {
  e.forEach(function(t) {
    Array.isArray(t) ? Ze(t, r) : r.push(t);
  });
}
function He(e) {
  let r = [];
  return Ze(e, r), r;
}
var Qe = (...e) => He(e).filter(Boolean), er = (e, r) => {
  let t = {}, o = Object.keys(e), s = Object.keys(r);
  for (let n of o)
    if (s.includes(n)) {
      let i = e[n], a = r[n];
      typeof i == "object" && typeof a == "object" ? t[n] = er(i, a) : Array.isArray(i) || Array.isArray(a) ? t[n] = Qe(a, i) : t[n] = a + " " + i;
    } else
      t[n] = e[n];
  for (let n of s)
    o.includes(n) || (t[n] = r[n]);
  return t;
}, Te = (e) => !e || typeof e != "string" ? e : e.replace(/\s+/g, " ").trim(), Rt = { twMerge: !0, twMergeConfig: {}, responsiveVariants: !1 }, rr = (e) => e || void 0, Z = (...e) => rr(He(e).filter(Boolean).join(" ")), le = null, T = {}, he = !1, K = (...e) => (r) => r.twMerge ? ((!le || he) && (he = !1, le = z(T) ? St : xt({ ...T, extend: { theme: T.theme, classGroups: T.classGroups, conflictingClassGroupModifiers: T.conflictingClassGroupModifiers, conflictingClassGroups: T.conflictingClassGroups, ...T.extend } })), rr(le(Z(e)))) : Z(e), Ie = (e, r) => {
  for (let t in r)
    e.hasOwnProperty(t) ? e[t] = Z(e[t], r[t]) : e[t] = r[t];
  return e;
}, $t = (e, r) => {
  let { extend: t = null, slots: o = {}, variants: s = {}, compoundVariants: n = [], compoundSlots: i = [], defaultVariants: a = {} } = e, c = { ...Rt, ...r }, w = t != null && t.base ? Z(t.base, e == null ? void 0 : e.base) : e == null ? void 0 : e.base, f = t != null && t.variants && !z(t.variants) ? er(s, t.variants) : s, R = t != null && t.defaultVariants && !z(t.defaultVariants) ? { ...t.defaultVariants, ...a } : a;
  !z(c.twMergeConfig) && !kt(c.twMergeConfig, T) && (he = !0, T = c.twMergeConfig);
  let M = z(t == null ? void 0 : t.slots), O = z(o) ? {} : { base: Z(e == null ? void 0 : e.base, M && (t == null ? void 0 : t.base)), ...o }, E = M ? O : Ie({ ...t == null ? void 0 : t.slots }, z(O) ? { base: e == null ? void 0 : e.base } : O), x = z(t == null ? void 0 : t.compoundVariants) ? n : Qe(t == null ? void 0 : t.compoundVariants, n), k = (h) => {
    if (z(f) && z(o) && M)
      return K(w, h == null ? void 0 : h.class, h == null ? void 0 : h.className)(c);
    if (x && !Array.isArray(x))
      throw new TypeError(`The "compoundVariants" prop must be an array. Received: ${typeof x}`);
    if (i && !Array.isArray(i))
      throw new TypeError(`The "compoundSlots" prop must be an array. Received: ${typeof i}`);
    let H = (l, p, d = [], g) => {
      let b = d;
      if (typeof p == "string")
        b = b.concat(Te(p).split(" ").map((m) => `${l}:${m}`));
      else if (Array.isArray(p))
        b = b.concat(p.reduce((m, y) => m.concat(`${l}:${y}`), []));
      else if (typeof p == "object" && typeof g == "string") {
        for (let m in p)
          if (p.hasOwnProperty(m) && m === g) {
            let y = p[m];
            if (y && typeof y == "string") {
              let v = Te(y);
              b[g] ? b[g] = b[g].concat(v.split(" ").map((A) => `${l}:${A}`)) : b[g] = v.split(" ").map((A) => `${l}:${A}`);
            } else
              Array.isArray(y) && y.length > 0 && (b[g] = y.reduce((v, A) => v.concat(`${l}:${A}`), []));
          }
      }
      return b;
    }, N = (l, p = f, d = null, g = null) => {
      var b;
      let m = p[l];
      if (!m || z(m))
        return null;
      let y = (b = g == null ? void 0 : g[l]) != null ? b : h == null ? void 0 : h[l];
      if (y === null)
        return null;
      let v = Ce(y), A = Array.isArray(c.responsiveVariants) && c.responsiveVariants.length > 0 || c.responsiveVariants === !0, $ = R == null ? void 0 : R[l], j = [];
      if (typeof v == "object" && A)
        for (let [ne, ve] of Object.entries(v)) {
          let or = m[ve];
          if (ne === "initial") {
            $ = ve;
            continue;
          }
          Array.isArray(c.responsiveVariants) && !c.responsiveVariants.includes(ne) || (j = H(ne, or, j, d));
        }
      let tr = v != null && typeof v != "object" ? v : Ce($), oe = m[tr || "false"];
      return typeof j == "object" && typeof d == "string" && j[d] ? Ie(j, oe) : j.length > 0 ? (j.push(oe), j) : oe;
    }, Q = () => f ? Object.keys(f).map((l) => N(l, f)) : null, ee = (l, p) => {
      if (!f || typeof f != "object")
        return null;
      let d = new Array();
      for (let g in f) {
        let b = N(g, f, l, p), m = l === "base" && typeof b == "string" ? b : b && b[l];
        m && (d[d.length] = m);
      }
      return d;
    }, W = {};
    for (let l in h)
      h[l] !== void 0 && (W[l] = h[l]);
    let B = (l, p) => {
      var d;
      let g = typeof (h == null ? void 0 : h[l]) == "object" ? { [l]: (d = h[l]) == null ? void 0 : d.initial } : {};
      return { ...R, ...W, ...g, ...p };
    }, F = (l = [], p) => {
      let d = [];
      for (let { class: g, className: b, ...m } of l) {
        let y = !0;
        for (let [v, A] of Object.entries(m)) {
          let $ = B(v, p);
          if (Array.isArray(A)) {
            if (!A.includes($[v])) {
              y = !1;
              break;
            }
          } else if ($[v] !== A) {
            y = !1;
            break;
          }
        }
        y && (g && d.push(g), b && d.push(b));
      }
      return d;
    }, D = (l) => {
      let p = F(x, l);
      if (!Array.isArray(p))
        return p;
      let d = {};
      for (let g of p)
        if (typeof g == "string" && (d.base = K(d.base, g)(c)), typeof g == "object")
          for (let [b, m] of Object.entries(g))
            d[b] = K(d[b], m)(c);
      return d;
    }, q = (l) => {
      if (i.length < 1)
        return null;
      let p = {};
      for (let { slots: d = [], class: g, className: b, ...m } of i) {
        if (!z(m)) {
          let y = !0;
          for (let v of Object.keys(m)) {
            let A = B(v, l)[v];
            if (A === void 0 || (Array.isArray(m[v]) ? !m[v].includes(A) : m[v] !== A)) {
              y = !1;
              break;
            }
          }
          if (!y)
            continue;
        }
        for (let y of d)
          p[y] = p[y] || [], p[y].push([g, b]);
      }
      return p;
    };
    if (!z(o) || !M) {
      let l = {};
      if (typeof E == "object" && !z(E))
        for (let p of Object.keys(E))
          l[p] = (d) => {
            var g, b;
            return K(E[p], ee(p, d), ((g = D(d)) != null ? g : [])[p], ((b = q(d)) != null ? b : [])[p], d == null ? void 0 : d.class, d == null ? void 0 : d.className)(c);
          };
      return l;
    }
    return K(w, Q(), F(x), h == null ? void 0 : h.class, h == null ? void 0 : h.className)(c);
  }, P = () => {
    if (!(!f || typeof f != "object"))
      return Object.keys(f);
  };
  return k.variantKeys = P(), k.extend = t, k.base = w, k.slots = E, k.variants = f, k.defaultVariants = R, k.compoundSlots = i, k.compoundVariants = x, k;
};
export {
  Ot as a,
  $t as c,
  xt as e,
  Et as f,
  zt as o,
  jt as p,
  Er as s
};
